export const initialValues = {
  applicantInformation: {
    fullName: '',
    contactEmail: '',
  },
  propertyDetails: {
    streetAddress: '',
    city: 'Hyattsville',
    state: 'Maryland',
    zipCode: '',
    neighborhood: '',
    constructionType: '',
    isPropertyLessThan15YearsOld: '',
    familyType: '',
    rentType: {
      studios: '',
      oneBedroom: '',
      twoBedrooms: '',
      threeBedrooms: '',
    },
    avgSalesPrice: '',
    moreInfo: '',
    additionalDocs: [],
  },
  ownershipInformation: {
    entityName: '',
    contactPersonName: '',
    contactPersonEmail: '',
    streetAddress: '',
    city: '',
    state: '',
    zipCode: '',
    phone: '',
    website: '',
    formationDate: '',
    fullTimeEmployeeCount: '',
    anyApply: [],
  },
  propertyManagement: {
    entityName: '',
    contactPersonName: '',
    contactPersonEmail: '',
    streetAddress: '',
    city: '',
    state: '',
    zipCode: '',
    phone: '',
    website: '',
    formationDate: '',
    fullTimeEmployeeCount: '',
    anyApply: [],
  },
};
